import { ReducerState } from '../../store.types';

export const analyticsSelector = ({ analytics }: ReducerState) => analytics;
